import arrow from '../../assets/new-ui/economy-arrow.png'
import arrowMobile from '../../assets/new-ui/economy-arrow-mobile.png'
import { economyList } from '../../services/economyData'
import EconomyBubble from '../economy/EconomyBubble'
import Bubble from '../coral/Bubble'

export default function EconomyGraph() {
  return (
    <div className='economyGraph'>
      <Bubble top={0} bottom={0} />
      <img className='economyArrow' src={arrow} alt='economy graph' />
      <img className='economyArrowMobile' src={arrowMobile} alt='economy graph' />
      <div className='bubbleIcon manufacture'>
        <EconomyBubble 
          img={economyList.manufacture.img}
          imgMobile={economyList.manufacture.imgMobile}
          text={economyList.manufacture.text}
        />
      </div>
      <div className='bubbleIcon crop'>
        <EconomyBubble 
          img={economyList.crop.img}
          imgMobile={economyList.crop.imgMobile}
          text={economyList.crop.text}
        />
      </div>
      <div className='bubbleIcon mine'>
        <EconomyBubble 
          img={economyList.mine.img}
          imgMobile={economyList.mine.imgMobile}
          text={economyList.mine.text}
        />
      </div>
      <div className='bubbleIcon breeding'>
        <EconomyBubble 
          img={economyList.breeding.img}
          imgMobile={economyList.breeding.imgMobile}
          text={economyList.breeding.text}
        />
      </div>
      <div className='bubbleIcon products'>
        <EconomyBubble 
          img={economyList.products.img}
          imgMobile={economyList.products.imgMobile}
          text={economyList.products.text}
        />
      </div>
      <div className='bubbleIcon resources'>
        <EconomyBubble 
          img={economyList.resources.img}
          imgMobile={economyList.resources.imgMobile}
          text={economyList.resources.text}
        />
      </div>
      <div className='bubbleIcon meat'>
        <EconomyBubble 
          img={economyList.meat.img}
          imgMobile={economyList.meat.imgMobile}
          text={economyList.meat.text}
        />
      </div>
      <div className='bubbleIcon upgrade'>
        <EconomyBubble 
          img={economyList.upgrade.img}
          imgMobile={economyList.upgrade.imgMobile}
          text={economyList.upgrade.text}
        />
      </div>
      <div className='bubbleIcon war'>
        <EconomyBubble 
          img={economyList.war.img}
          imgMobile={economyList.war.imgMobile}
          text={economyList.war.text}
        />
      </div>
      <div className='bubbleIcon bank'>
        <EconomyBubble 
          img={economyList.bank.img}
          imgMobile={economyList.bank.imgMobile}
          text={economyList.bank.text}
        />
      </div>
      <div className='bubbleIcon commerce'>
        <EconomyBubble 
          img={economyList.commerce.img}
          imgMobile={economyList.commerce.imgMobile}
          text={economyList.commerce.text}
        />
      </div>
      <div className='bubbleIcon reinvest'>
        <EconomyBubble 
          img={economyList.reinvest.img}
          imgMobile={economyList.reinvest.imgMobile}
          text={economyList.reinvest.text}
        />
      </div>
      <div className='bubbleIcon gdc'>
        <EconomyBubble 
          img={economyList.gdc.img}
          imgMobile={economyList.gdc.imgMobile}
          text={economyList.gdc.text}
        />
      </div>
      <div className='bubbleIcon gdcBNB'>
        <EconomyBubble 
          img={economyList.gdcBNB.img}
          imgMobile={economyList.gdcBNB.imgMobile}
          text={economyList.gdcBNB.text}
        />
      </div>
      <div className='bubbleIcon shark'>
        <EconomyBubble 
          img={economyList.shark.img}
          imgMobile={economyList.shark.imgMobile}
          text={economyList.shark.text}
        />
      </div>
      <div className='bubbleIcon combine'>
        <EconomyBubble 
          img={economyList.combine.img}
          imgMobile={economyList.combine.imgMobile}
          text={economyList.combine.text}
        />
      </div>
      <div className='bubbleIcon land'>
        <EconomyBubble 
          img={economyList.land.img}
          imgMobile={economyList.land.imgMobile}
          text={economyList.land.text}
        />
      </div>
      <div className='bubbleIcon profit'>
        <EconomyBubble 
          img={economyList.profit.img}
          imgMobile={economyList.profit.imgMobile}
          text={economyList.profit.text}
        />
      </div>
    </div>
  )
}